/** Give any element the "copy-field" class to create a button that copies text
 * from a text or textarea input field to the user's clipboard (if supported).
 *
 * Assign the input field's id value to the button's "data-copyable" attribute.
 * Tag an element with the "copy-success" class to provide feedback on success.
 */ 

class CopyFieldToClipboard {
  constructor() {
    N2.bindHandler('click', '.copy-field', (e) => {
      this.copyField(e.target);
    });
  }

  copyField(element) {
    let $copyable = $( "#" + $(element).data("copyable") );
    $copyable.select();

    try {
      if (this.isCopyable($copyable) && document.execCommand('copy')) {
        new N2Styles.toast("Content has been copied to your clipboard!")
      } else {
        this.promptManualCopy();
      }
    } catch(err) {
      this.promptManualCopy();
    }
  }

  promptManualCopy() {
    alert("Press Ctrl-C or Cmd-C to copy the text.");
  }

  isCopyable(copyable) {
    return document.queryCommandSupported('copy')
        && document.queryCommandEnabled('copy')
        && (copyable.is("input[type='text']") || copyable.is("input[type='textarea']")
        || copyable.is("textarea"))
  }
}

export default CopyFieldToClipboard
